module.exports = __webpack_public_path__ + "static/media/challenge-1.ac8de8f0.png";